import axios from "axios";
import { Coupon } from "./Coupon";
import { Product } from "./Product";
import { percentageOfXInCents } from "./Teller";
import { inDollars } from './Teller'

// declare global {
//     interface Window { drivescout_config: any; }
// }

// window.drivescout_config = window.drivescout_config || {};

class Cart {
    // data: { 
    //     products: any[]; 
    //     coupon?: Coupon
    // };
    // $shopRules?: ShopRules;
    // loading: boolean;
    constructor() {
        this.cart_hash = 'drivescout-cart-' + window.drivescout_config.shop.info.id;
        this.data = {
            'products': [],
            // 'coupon': null
        }
        this.$shopRules = null;
        this.loading = false;
        this.isLoading = this.isLoading.bind(this);
        this.update = this.update.bind(this);
        this.submit = this.submit.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onFail = this.onFail.bind(this)
    }

    shopRules() {
        return this.$shopRules;
    }

    // setShopRules(rules:ShopRules) {
    setShopRules(rules) {
        this.$shopRules = rules;
    }

    onSuccess(response) {
        this.loading = false;
    }

    onFail(error) {
        this.loading = false;
    }

    // submit(method:string, url:string) {
    submit(method, url) {
        return axios[method](url)
            .then(this.onSuccess)
            .catch(this.onFail)
    }

    setCartData(data) {
        if (data.hasOwnProperty('coupon')) {
            data.coupon = new Coupon(data.coupon)
        }
        data.products = data.products.map((p) => {
            return new Product(p);
        });
        this.data = data;
    }

    async update() {
        this.loading = true;
        if (this.shopRules().cacheCompatibilityEnabled()) {
            try {
                const $cart = JSON.parse(window.localStorage.getItem(this.cart_hash));
                this.setCartData($cart)
                this.data.totalInDollars = inDollars(this.totalDue());
                this.data.subTotal = this.orderValueInCents();
                this.data.total = this.totalDue();
                this.data.subTotalInDollars = inDollars(this.orderValueInCents());
                this.data.amountDue = this.totalDue();
                this.loading = false;
            } catch(Error) {
                this.onFail(Error);
            }
        } else {
            try {
                this.loading = true;
                let response = await axios.get(window.drivescout_config.shopUrl + '?action=get-cart');
                this.setCartData(response.data);
                this.loading = false;
            } catch(Error) {
                this.onFail(Error);
            }
        }
    }

    addProduct(productID) {
        this.loading = true;

        if (this.shopRules().cacheCompatibilityEnabled()) {
            axios.get(window.drivescout_config.shopUrl + '?action=get-product&product_id=' + productID)
            .then(response => {
                const products = [...this.data.products].concat(new Product(response.data.product));
                this.data.products = products;
                window.localStorage.setItem(this.cart_hash, JSON.stringify(this.data));
            })
            .then(this.update)
            .catch(this.onFail);
        } else {
            axios.get(window.drivescout_config.shopUrl + '?action=add-to-cart&product_id=' + productID)
            .then(response => {
            })
            .then(this.update)
            .catch(this.onFail);
        }
    }

    removeProduct(index) {
        this.loading = true;

        if (this.shopRules().cacheCompatibilityEnabled()) {
            const products = [...this.data.products].filter((product, i) => {
                return index !== i;
            });
            this.data.products = products;
            window.localStorage.setItem(this.cart_hash, JSON.stringify(this.data));
            this.update();
            this.loading = false;
        } else {
            axios.get(window.drivescout_config.shopUrl + '?action=remove-from-cart&product_index=' + index)
            .then(response => {
            })
            .then(this.update)
            .catch(this.onFail);
            this.loading = false;
        }
    }

    // applyCoupon(coupon_code:string) {
    applyCoupon(coupon_code) {
        this.loading = true;

        if (this.shopRules().cacheCompatibilityEnabled()) {
            axios.get(window.drivescout_config.shopUrl + '?action=apply-coupon&coupon=' + coupon_code)
            .then(response => {
                this.data.coupon = response.data.coupon;
                window.localStorage.setItem(this.cart_hash, JSON.stringify(this.data));
            })
            .then(this.update)
            .catch(Error => {
                window.alert('The provided coupon was invalid.');
                this.loading = false;
                this.onFail(Error);
            });
        } else {
            axios.get(window.drivescout_config.shopUrl + '?action=apply-coupon&coupon=' + coupon_code)
            .then(response => {
                this.data.coupon = response.data.coupon;
            })
            .then(this.update)
            .catch(Error => {
                window.alert('The provided coupon was invalid.');
                this.loading = false;
                this.onFail(Error);
            });
        }
    }

    removeCoupon() {
        this.loading = true;
        if (this.shopRules().cacheCompatibilityEnabled()) {
            delete this.data.coupon;
            window.localStorage.setItem(this.cart_hash, JSON.stringify(this.data));
            this.update();
        } else {
            axios.get(window.drivescout_config.shopUrl + '?action=remove-coupon')
                .then(response => {
                })
                .then(this.update)
                .catch(this.onFail);
        }
    }

    isEmpty() {
        return this.data.products.length === 0;
    }

    hasCoupon() {
        return this.data.hasOwnProperty('coupon'); 
    }

    isLoading() {
        return this.loading === true;
    }

    clear() {
        this.loading = true;
        axios.get(window.drivescout_config.shopUrl + '?action=clear-cart').then(response => {
            this.data = {
                'products': []
            }
            this.loading = false;
        }).catch(this.onFail)
        window.localStorage.removeItem(this.cart_hash)
    }

    products() {
        return this.data.products;
    }

    coupon() {
        return this.data.coupon;
    }

    orderValueInCents() {
        return this.data.products.reduce((carry, product) => {
            return carry + parseInt(product.price());
        }, 0);
    }

    // applyCouponTo(amount:number) {
    applyCouponTo(amount) {
        if (this.hasCoupon()) {
            if (this.coupon().type() === 'fixed') {
                return amount - this.coupon().amount();
            }

            if (this.coupon().type() === 'percentage') {
                return amount - percentageOfXInCents(amount, this.coupon().amount())
            }
        }
        return amount;
    }

    /**
     * Calculate the surcharge in cents for a given value in cents
     */
    // calculateSurcharge(amount:number):number {
    calculateSurcharge(amount){
        if (this.shopRules().surchargeBilledSeparately() === false) {
            return 0;
        }

        if (this.shopRules().surchargeBilledSeparately()) {
            return percentageOfXInCents(amount, this.shopRules().surchargeAmount());
        }

        return 0;
    }

    totalBilled() {
        // TODO: This if statement is for pay-later. It should only be take into account when
        //       pay later is enabled. Pay Later should be added to the Shop Info endpoint
        // if (this.order().payments().length > 0) {
        //     return this.applySurchargeTo(this.totalPaymentsInCents());
        // }

        return this.applySurchargeTo(this.totalDue());
    }

    // applySurchargeTo(amount:number):number {
    applySurchargeTo(amount){
        return amount + this.calculateSurcharge(amount)
    }

    /**
     * Returns the amount in cents due. Computed as the total product price in cents - applied coupons
     */
    // totalDue():number {
    totalDue() {
        if (this.hasCoupon() === false) {
            return this.orderValueInCents();
        }

        let totalDue = this.applyCouponTo(this.orderValueInCents())

        return totalDue;
    }

    allowsPayLater() {
    // allowsPayLater():boolean {
        return this.products().filter(product => {
            return product.allowsPayLater();
        }).length > 0;
    }

    requiresDeposit() {
    // requiresDeposit():boolean {
        if (this.allowsPayLater() === false) {
            return false;
        }

        return this.products().filter(product => {
            return product.requiresDeposit();
        }).length > 0;
    }

    minimumDepositAmountRequired() {
    // minimumDepositAmountRequired():number {
        if (this.allowsPayLater() === false) {
            return this.totalDue();
        }

        return this.products().reduce(($carry, product) => {
            return product.calculateMinimumDepositRequired(product.price()) + $carry;
        }, 0);
    }

}

export default Cart;
